import OfficialDiaryAppService from "../../../../application/platform/official-daily/official-daily-app-service";
import { ACTION_TYPES, useConsultaDiarioOficialDispatch, useConsultaDiarioOficialState } from "./consulta-diario-oficial-context";
import { IOfficialDiaryPagedRequest } from "../../../../model/official-daily/request/official-diary-paged-request";
import dayjs from "dayjs";
import ApplicationAppService from "../../../../application/platform/application-app-service";

export const useConsultaDiarioOficialController = () => {
    const { officialDiaryPagedRequest } = useConsultaDiarioOficialState();
    const consultaDiarioOficialDispatch = useConsultaDiarioOficialDispatch();
    const applicationData = ApplicationAppService.getAuthenticationData();

    const loadData = async (request: IOfficialDiaryPagedRequest) => {

        if (request !== null && request.page !== undefined && request.pageSize !== undefined) {
            consultaDiarioOficialDispatch({
                type: ACTION_TYPES.setIsLoadingData,
                payload: true,
            });

            const data = await OfficialDiaryAppService.list(request);

            consultaDiarioOficialDispatch({
                type: ACTION_TYPES.setOfficialDiaryPagedResponse,
                payload: data,
            });

            consultaDiarioOficialDispatch({
                type: ACTION_TYPES.setIsLoadingData,
                payload: false,
            });
        }

    }

    const onChangePagination = async (page: number, pageSize: number) => {

        if (page !== undefined && page !== undefined && pageSize !== undefined) {
            // Proteção: evita re-disparo se valores não mudaram
            if (officialDiaryPagedRequest?.page === page &&
                officialDiaryPagedRequest?.pageSize === pageSize) {
                return;
            }

            var request = { ...officialDiaryPagedRequest, page, pageSize } as IOfficialDiaryPagedRequest;

            consultaDiarioOficialDispatch({
                type: ACTION_TYPES.setOfficialDiaryPagedRequest,
                payload: request,
            });


            await loadData(request);
        }
    }

    const handleOnChange = (e: any) => {
        let number = officialDiaryPagedRequest?.number;
        let year = officialDiaryPagedRequest?.year;
        let isClosed = officialDiaryPagedRequest?.isClosed;
        let clientId = officialDiaryPagedRequest?.clientId;

        if (e.target.name === "input-number") {
            number = e.target.value;
        }
        if (e.target.name === "input-year") {
            year = e.target.value;
        }

        if (e.target.name === "select-closed") {
            isClosed = e.target.value;
        }

        if (e.target.name === "select-client") {
            clientId = e.target.value;
        }

        consultaDiarioOficialDispatch({
            type: ACTION_TYPES.setOfficialDiaryPagedRequest,
            payload: { ...officialDiaryPagedRequest, clientId, isClosed, year, number },
        });
    };



    const clearFieldss = async () => {
        var request = { page: 0, pageSize: 50, number: "", year: "", clientId: applicationData?.company.id, isClosed: ""} as IOfficialDiaryPagedRequest;

        consultaDiarioOficialDispatch({
            type: ACTION_TYPES.setOfficialDiaryPagedRequest,
            payload: request,
        });

        await loadData(request);
    }

    return { loadData, handleOnChange, onChangePagination, clearFieldss };
}